import clsx from "clsx";
import { forwardRef } from "react";

export const ActionButton = forwardRef(({ text, Icon, color='primary', textColor=null, size='md', disabled=false, selected=false, onClick=null, className='rounded-md', ...rest }, ref) => {
  const bgColorClass =
    disabled ? 'bg-perception-gray-800' :
    color === 'primary' ? 'bg-perception-blue' :
    color === 'secondary' ? 'bg-perception-gray-700' :
    color === 'white' ? 'bg-white' :
    color === 'cancel' ? 'bg-perception-gray-500' :
    color === 'danger' ? 'bg-perception-error-500' :
    color === 'success' ? 'bg-perception-success-600' :
    null;

  const textColorClass =
    disabled ? 'text-perception-gray-500 cursor-not-allowed' :
    textColor !== null ? textColor :
    color === 'white' ? 'text-perception-gray-800' :
    color === 'cancel' ? 'text-black' :
    color === 'danger' ? 'text-white' :
    color === 'success' ? 'text-white' :
    'text-white';

  let iconSize = size === 'sm' ? 'size-4' : size === 'lg' ? 'size-6' : 'size-5';
  if (text && Icon) iconSize += size === 'sm' ? ' mr-2' : size === 'lg' ? ' mr-3' : ' mr-2';

  const getSizeClasses = () => {
    return size === 'sm' ? 'text-sm px-2 py-1' :
      size === 'lg' ? 'text-xl px-4 py-2' :
        'px-3 py-2'; // default & md
  };

  return (
    <button
      className={clsx(
        textColorClass,
        bgColorClass,
        getSizeClasses(),
        'inline-flex items-center',
        selected && 'brightness-90',
        className
      )}
      onClick={() => onClick?.()}
      disabled={disabled}
      ref={ref} {...rest}
    >
      {Icon && <Icon aria-hidden="true" className={iconSize} />}
      {text}
    </button>
  );
});